import { FC } from "react";


interface IStrengthUsage {
    strengthUsage: any,
    key?: number
}

const StrengthUsage: FC<IStrengthUsage> = (props) => {
    
    const strengthUsage = props;

    let usagePercentage: any = strengthUsage.strengthUsage.percentage;
    

    return (
        <div className={`progress--circle progress--${usagePercentage}`}>
          <div className="progress__number">{usagePercentage}%</div>
        </div>
    )
};

export default StrengthUsage;